import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { NgxsModule } from '@ngxs/store';
import { MenuService } from '@x/ecommerce-shop/app/core/menu/services/menu.service';
import { TaxonMenuService } from '@x/ecommerce-shop/app/core/menu/services/taxon-menu.service';
import { UrlService } from '@x/ecommerce-shop/app/core/url/url.service';
import { MenuState } from './state/menu.state';

@NgModule({
  providers: [MenuService, TaxonMenuService, UrlService],
  imports: [
    CommonModule,
    NgxsModule.forFeature([MenuState]),
    RouterModule,
    MatTabsModule,
    MatButtonModule,
  ],
})
export class MenuModule {}
